export default __webpack_public_path__ + "ubisoft-playtest-icon-garbage-red.webp";